import { Component, EventEmitter, HostBinding, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { LocLabel } from '../../../clickable-row-table/models/data-table-config.models';

@Component({
  selector: 'app-input-header',
  templateUrl: './input-header.component.html',
  styleUrls: ['./input-header.component.scss']
})
export class InputHeaderComponent implements OnInit, OnChanges {
  @Input() labelKey?: string | LocLabel | null;

  @Input() required?: boolean | null;
  @Input() reset?: boolean | null;

  @Output() onReset = new EventEmitter<MouseEvent>();

  @HostBinding('class') class = '';

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    const reset = changes.reset?.currentValue ?? this.reset;
    const label = changes.labelKey?.currentValue ?? this.labelKey;
    this.class = label ? '' : reset ? 'reset-only' : 'empty';
  }
}
